<template>
  <v-app>
    <div id="dashboard">
    <!--  <v-container fluid grid-list-lg> -->
      <v-container fluid grid-list-md>
      <v-layout justify-center row wrap>

        <v-toolbar dark color="green lighten-1" class="elevation-1">
          <v-btn dark flat to="/csvexport">Export CSV
          </v-btn>
          <v-btn dark flat to="/report">View E911
          </v-btn>
          <v-spacer></v-spacer>
           <v-text-field
            dark
            v-model="pagination.search"
            append-icon="search"
            label='Search'
            single-line
            hide-details
            >
            </v-text-field>
        </v-toolbar>

          <v-flex xs12>
            <v-data-table
            v-model="selected"
            :headers="headers"
            :items="filteredCompanies"
            class="elevation-1"
            :search="pagination.search"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            >
            <template slot="headers" slot-scope="props">
                <tr class="grey lighten-2">
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                    align="left"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    width="0%"
                  >
                    <div v-if="filters.hasOwnProperty(header.value)">
                      <v-select flat hide-details small multiple clearable
                      :items="columnValueList(header.value)" v-model="filters[header.value]"
                      >
                      </v-select>
                    </div>
                  </th>
                </tr>
              </template>


            <template slot="items" slot-scope="props">
                <td width="20%">{{ props.item.company }}</td>
                <td width="12%">{{ props.item.did }}</td>
                <td width="12%">{{ props.item.tempdid }}</td>
                <td width="3%">
                  <p v-if="props.item.e911"><v-icon  color="green">done</v-icon></p>
                  <p v-else><v-icon  color="grey">minimize</v-icon></p>
                </td>
                <td width="10%">{{ props.item.e911address }}</td>
                <td width="20%">{{ props.item.notes }}</td>
                <td width="5%" class="text-xs-right">
                  <v-btn small v-bind:to="{name: 'edit', params: {did: props.item.did}}" icon>
                    <v-icon color="blue">edit</v-icon>
                  </v-btn>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ pagination.search }}" found no results.
            </v-alert>
          </v-data-table>
          </v-flex>
      </v-layout>
</v-container>

 <span style="height: 100px; position: relative">
    <v-fab-transition>
        <v-btn
                to="/add"
                color="blue"
                round
                fixed
                bottom
                right
                fab
                @click="saveRowsPerPage"
              >
              <v-icon large color="white">add_circle_outline</v-icon>
        </v-btn>
    </v-fab-transition>
  </span>

</div>
</v-app>
</template>

<script>
import db from "./firebaseinit";
import firebase from 'firebase';
import { mapState, mapMutations } from 'vuex'
var Tabulator = require("tabulator-tables"); //import Tabulator library


export default {
  name: "dashboard",
  data() {
    return {
      search: "",
      dialog: false,
      inventory: [],
      companies: [],
      selected: [],
      filters: {
       company: []
      },
      did: null,
      users: [],
      Admin: false,
      Standard: false,
      filterSelection: 'Example Co',
      rowsPerPageItems: [5, 10, 25, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      pagination: {
        search: "",
        rowsPerPage: this.$store.state.rowsPerPage,
        totalItems: null
      },
      tableData: [
        {
          company: "company",
          did: "did",
          tempdid: "tempdid",
          e911: "e911",
          e911address: "e911address",
          notes: "notes",
          }
      ], //data for table to display
      headers: [
        {
          text: "Company",
          align: "left",
          value: "company"
        },
        { text: "DID",
          align: "left",
          value: "did"
        },
        { text: "Temp DID",
          align: "left",
          value: "tempdid"
        },
        { text: "E911", align: "left",  value: "e911" },
        {
          text: "E911 Address",
          align: "left",
          value: "e911address",
        },
        { text: "Notes", align: "left",  value: "notes" },
        { text: "Actions", align: "left" }
      ]
    };
  },
  created() {
    var that = this
    var database = db.collection("inventory")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company,
            'devicetype': doc.data().devicetype,
            'did': doc.data().did,
            'tempdid': doc.data().tempdid,
            'e911': doc.data().e911,
            'e911address': doc.data().e911address,
            'extension': doc.data().extension,
            'notes': doc.data().notes,
            'user': doc.data().user
          };
          this.inventory.push(data);
        });
      })
      .onSnapshot(function(doc) {
        console.log("Current data: ", doc.data());
    });



      if(firebase.auth().currentUser) {
      this.isLoggedIn = true;
      this.currentUser = firebase.auth().currentUser.email;
      //Gets User Group//
      console.log(this.currentUser)
      console.log(this.users)
      var user = this.currentUser
      var a = this.users.indexOf(user)
      console.log(a)
      };
      var users = db.collection("users")
      .orderBy("user")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'user': doc.data().user,
            'admin': doc.data().admin,
            'standard': doc.data().standard
          };
          this.users.push(data);
        });
      });
      db.collection("companies")
      .orderBy("company")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          const data = {
            'company': doc.data().company
          };
          this.companies.push(data);
        });
      });
     var query = firebase.firestore().collection('users')
      .where("user", '==', this.currentUser)
      .get().then(querySnapshot => {
        querySnapshot.forEach(doc => {
        console.log(doc.data())
        this.admin = doc.data().admin
        this.standard = doc.data().standard
        this.permissions = true
        })
        console.log("Admin: " + this.admin)
        console.log("Standard: " + this.standard)
        console.log(this.currentUser)
      });
  },
  mounted(){
  },
  methods: {
   columnValueList(val) {
      var companyFilter = this.inventory.map(d => d[val]);
      var sortedCompanyFilter = companyFilter.sort(function(x,y){
        var a = String(x).toUpperCase();
        var b = String(y).toUpperCase();
        if (a > b)
          return 1
        if (a < b)
          return -1
        return 0;
      });
      return sortedCompanyFilter
    },
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  },
  computed: {
    filteredCompanies() {
      return this.inventory.filter(d => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f])
        })
      })
    }
  },
    ...mapMutations(['rowsPerPage'])
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue